'use client';

import type { FC } from 'react';
import { useNavigation } from '../../../contexts/NavigationContext';
import { useWikiDrops, type WikiDropsTarget } from '../../../queries/useWikiDropsQuery';
import { wikiUiText } from '../wikiText';

import { WikiRecentDrops } from './WikiRecentDrops';
import type { Language } from '../../../i18n/types';

interface WikiRecentDropsBlockProps {
  lang: Language;
  target: WikiDropsTarget;
  labelPlain?: boolean;
  className?: string;
}

// WHY: выпадения живые, с «N мин назад» — их запрашивает клиент, а не HTML страницы, который кэшируется на 5 минут
export const WikiRecentDropsBlock: FC<WikiRecentDropsBlockProps> = ({ lang, target, labelPlain, className }) => {
  const { navigate } = useNavigation();
  const { data, isPending, isError } = useWikiDrops(lang, target);
  if (isError) return null;
  return (
    <WikiRecentDrops
      drops={data ?? []}
      isLoading={isPending}
      lang={lang}
      t={wikiUiText(lang)}
      onOpenUser={(userId) => navigate('profile', { userId })}
      labelPlain={labelPlain}
      className={className}
    />
  );
};
